import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instagram-real',
  templateUrl: './instagram-real.component.html',
  styleUrls: ['./instagram-real.component.css']
})
export class InstagramRealComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
